import React from 'react'
import PropTypes from 'prop-types'

import { useSignUp } from '@/components/Providers/SignUpProvider'
import CheckoutSideEmail from '@/components/blocks/CheckoutSideEmail'
import CheckoutSideEmailNeatHome from '@/components/blocks/CheckoutSideEmailNeatHome'
import { NEAT_HOME_TRIAL_SKU } from '@/constants'

import SignUpLayout from './SignUpLayout'

const NEAT_HOME_SKUS = ['neathomeyr', 'neathomevipyr', NEAT_HOME_TRIAL_SKU]

/**
 * The frame the email step and the profile step share.
 *
 * It is mounted by the step switch rather than by either step, and that is the
 * whole point: a frame rendered inside each step would be a different element
 * at the switch's child position on each side of the transition, so React would
 * unmount it and the move between the two steps would read as a page change.
 * Held here, the layout and the side panel stay mounted and only the left pane
 * swaps.
 *
 * The side panel is the email step's throughout, for both steps. The profile
 * step's own panel is therefore not rendered by this flow any more; its
 * components are untouched and still exported for any other caller.
 */
export default function AccountSetupFrame({ children }) {
  const { plan } = useSignUp()

  return (
    <SignUpLayout
      sideContent={NEAT_HOME_SKUS.includes(plan?.sku) ? <CheckoutSideEmailNeatHome /> : <CheckoutSideEmail />}
    >
      {children}
    </SignUpLayout>
  )
}

AccountSetupFrame.propTypes = {
  children: PropTypes.node.isRequired,
}
